module.exports = __webpack_public_path__ + "static/media/togoria.a670c32e.jpg";